import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import comboGridKm from "@/extension/combo-gird-km"


addCustomWidgetSchema({
  type: 'comboGridKm',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '', // 唯一名称
    defaultValue: new Array(), // 默认值
    label: '字段模板',
    labelAlign: 'label-right-align',
    labelWidth: '110',
    required: false,
    requiredHint: '',
    //-------------------
    weekCode: '',
    url: '/jumper-mih/nt/ntBaseTemplate/filterTemplate',
    noEditable: false,
    needTable: true,
    disabled: false,// 整个组件禁用
    border: false,
    inputClass: 'no-border-input',
    tableHeight: 255,
    placeholder: '请选择',//输入提示文字
    backgroundColor: '#3983b3',
    valColor: '#fff',
    fontSize: '12px',
    bcolor: '#3983b3',
  }
})  //加载组件Json Schema


Vue.component(comboGridKm.name, comboGridKm)  //注册组件

// 注册属性编辑框
PERegister.registerCPEditor('valColor', 'valColor-editor',
  PEFactory.createInputTextEditor('valColor', '选项字体色'))

PERegister.registerCPEditor('bcolor', 'bcolor-editor',
  PEFactory.createInputTextEditor('bcolor', '选项边框色'))

PERegister.registerCPEditor('backgroundColor', 'backgroundColor-editor',
  PEFactory.createInputTextEditor('backgroundColor', '选项背景色'))

PERegister.registerCPEditor('weekCode', 'weekCode-editor',
  PEFactory.createInputTextEditor('weekCode', '孕周字段名'))

PERegister.registerCPEditor('url', 'url-editor',
  PEFactory.createInputTextEditor('url', '接口地址'))


PERegister.registerCPEditor('inputClass', 'inputClass-editor',
  PEFactory.createInputTextEditor('inputClass', '文本框样式'))

PERegister.registerCPEditor('noEditable', 'noEditable-editor',
  PEFactory.createBooleanEditor('noEditable', '是否不可以编辑'))

PERegister.registerCPEditor('needTable', 'needTable-editor',
  PEFactory.createBooleanEditor('needTable', '快捷表格'))
PERegister.registerCPEditor('border', 'border-editor',
  PEFactory.createBooleanEditor('border', '文本框边框'))

// PERegister.registerCPEditor('tableHeight', 'tableHeight-editor',
//   PEFactory.createInputNumberEditor('tableHeight', '表格高度'))

// PERegister.registerCPEditor('tableHeight', 'tableHeight-editor',
//   PEFactory.createInputNumberEditor('tableHeight', '表格高度'))


//注册字段组件的代码生成器
// registerFWGenerator('alert', alertTemplateGenerator)  

